import { type SvgIconProps } from '@common/components/svgs/props';

function IconCheck(
  { size = 16, color = 'scheme-feedback-action-color', ...rest }: Readonly<SvgIconProps>,
) {
  return (
    <svg
      {...rest}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="svg-Check"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9643 6.35415L8.25716 19.0613L3.05005 13.8542L4.46426 12.4399L8.25716 16.2328L19.55 4.93994L20.9643 6.35415Z"
        fill={`var(--${color})`}
      />
    </svg>
  );
}

IconCheck.displayName = 'Check';

export default IconCheck;
